import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class AnchoredVector2D extends Primitive {
    anchor;
    vector;
    constructor(anchor, vector) {
        super(Type.AnchoredVector2D);
        this.anchor = anchor;
        this.vector = vector;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5jaG9yZWRWZWN0b3IyRC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvZ2VvbWV0cnlfMmQvQW5jaG9yZWRWZWN0b3IyRC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBQ3hDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFLOUIsTUFBTSxPQUFPLGdCQUFpQixTQUFRLFNBQVM7SUFDcEMsTUFBTSxDQUFTO0lBQ2YsTUFBTSxDQUFVO0lBRXpCLFlBQVksTUFBZSxFQUFFLE1BQWdCO1FBQzNDLEtBQUssQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLENBQUMsQ0FBQTtRQUM1QixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtRQUNwQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtJQUN0QixDQUFDO0NBQ0YifQ==